"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _index = _interopRequireDefault(require("./index.style"));
var _Card = _interopRequireDefault(require("../../Card"));
var _Button = _interopRequireDefault(require("../../Button"));
var _InputRangeDate = _interopRequireDefault(require("../InputRangeDate"));
var _Header = _interopRequireDefault(require("../../Header"));
var _NavLink = _interopRequireDefault(require("../../NavLink"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _Calendar = _interopRequireDefault(require("../Calendar"));
var _calendar = _interopRequireDefault(require("../../../assets/svg/calendar"));
var _VerticalDivider = _interopRequireDefault(require("../../Icons/VerticalDivider"));
var _dates = require("../../../utils/dates");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DatepickerMobile = props => {
  const classes = (0, _index.default)();
  const {
    datepickerIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    dividerInputIcon = /*#__PURE__*/_react.default.createElement(_VerticalDivider.default, null),
    resetDatesButtonLabel = 'Reset',
    incomingStartDate = '2021/03/01',
    incomingEndDate = '2021/03/25',
    minAvailableDate = '2021/01/30',
    maxAvailableDate = '2021/04/25',
    startDate = new Date(),
    endDate = new Date(),
    submitDatesButtonLabel = 'Done',
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    handleCloseModal = () => {},
    onDateChange = () => {},
    resetCalendar = () => {}
  } = props;
  const [state, setState] = (0, _react.useState)({
    ...(0, _dates.buildCalendarStateObject)(startDate, endDate),
    scrolled: false
  });
  const setDates = dates => {
    setState({
      ...state,
      ...dates
    });
  };
  const monthRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (monthRef.current && !state.scrolled) {
      monthRef.current.scrollIntoView();
      setState({
        ...state,
        scrolled: true
      });
    }
  }, [state]);
  const onCancelClick = () => {
    setState({
      ...(0, _dates.buildCalendarStateObject)(startDate, endDate),
      scrolled: false
    });
    handleCloseModal();
  };
  const onDoneClick = () => {
    setState({
      ...state,
      scrolled: false
    });
    onDateChange(state);
    handleCloseModal();
  };
  const onResetClick = () => {
    setState({
      ...(0, _dates.buildCalendarStateObject)(incomingStartDate, incomingEndDate),
      scrolled: false
    });
    resetCalendar();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mobileCalendar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerHeaderFixed
  }, /*#__PURE__*/_react.default.createElement(_Header.default, {
    position: "relative",
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(_NavLink.default, {
    component: "a",
    onClick: onCancelClick
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2",
    className: classes.datepickerHeaderLabel
  }, "Back"))), /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: classes.wrapDatepickerMobile
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerHeader
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    sm: 12,
    className: classes.datepickerHeaderItem
  }, /*#__PURE__*/_react.default.createElement(_InputRangeDate.default, {
    datepickerIcon: datepickerIcon,
    dividerInputIcon: dividerInputIcon,
    placeholderStartDate: placeholderStartDate,
    placeholderEndDate: placeholderEndDate,
    labelDatepicker: "",
    startDate: state.startDate,
    endDate: state.endDate,
    focusedInput: state.focusedInput
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datepickerMessages
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.underscore
  }), " Your sailing dates"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.rootDatepickerMobile
  }, /*#__PURE__*/_react.default.createElement(_Calendar.default, {
    maxAvailableDate: maxAvailableDate,
    minAvailableDate: minAvailableDate,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    startDate: state.startDate,
    endDate: state.endDate,
    onDateChange: setDates,
    numberOfMonths: 0,
    monthRef: monthRef
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.actionsFixed
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 12,
    sm: 12,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mobileButtonsGroup
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mobileButtons
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    buttonlabel: resetDatesButtonLabel,
    className: classes.resetButtonMobile,
    "data-testid": "resetDatesMobile",
    onClick: onResetClick
  }, resetDatesButtonLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "data-testid": "doneButtonMobile",
    buttonlabel: submitDatesButtonLabel,
    className: classes.doneButton,
    variant: "contained",
    color: "primary",
    onClick: onDoneClick
  }, submitDatesButtonLabel)))))));
};
var _default = exports.default = DatepickerMobile;